import { Modal, Box, Typography, Button } from '@mui/material'
import React from 'react'
import { styled, keyframes } from '@mui/material/styles'
import penguinFlyImg from '@assets/images/mascot/penguin-fly.png'
import { useTheme } from '@mui/material/styles'
import { useState } from 'react'
import { useLazyModulesGetUserModulesQuery } from '@app/services/auto-generated/modules'
import { useEffect } from 'react'
import { useNavigate } from '@lib/router'
import { useModulesSubmitModuleResultMutation } from '@app/services/auto-generated/modules'
import {
  useRevisionGetFeedbacksQuery,
  useRevisionListFeedbackRequestsQuery,
  useRevisionListRecordingsQuery,
} from '@app/services/auto-generated/revision'

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const float = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
`

const StyledBox = styled(Box)(({ theme }) => ({
  padding: '30px',
  borderRadius: '12px',
  backgroundColor: theme.palette.background.paper,
  boxShadow:
    theme.palette.mode === 'dark'
      ? '0 8px 24px rgba(0, 0, 0, 0.6)'
      : '0 8px 24px rgba(0, 0, 0, 0.2)',
  animation: `${fadeIn} 0.6s ease-out`,
  maxWidth: '500px',
  width: '100%',
  margin: '0 20px',
  display: 'flex',
  flexDirection: 'column',
}))

const FloatingImage = styled('img')({
  width: '150px',
  marginBottom: '25px',
  animation: `${float} 2s ease-in-out infinite`,
  alignSelf: 'center',
})

const GiftModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const theme = useTheme()
  const navigate = useNavigate()
  const [submit] = useModulesSubmitModuleResultMutation()
  const { data: feedbacks } = useRevisionListRecordingsQuery({})

  const handleGoToFeedback = async () => {
    // Find first unlocked feedback
    console.log('feedbacks', feedbacks)
    const unlockedFeedback = feedbacks.find((feedback) => !feedback.locked)
    console.log('feedback', unlockedFeedback)
    if (unlockedFeedback) {
      // Submit the module
      await submit({
        moduleResult: {
          id: 'GiftRecordingFeedbackModule',
          data: { completed: true },
        },
      }).unwrap()

      // Navigate to the feedback
      navigate(`/dashboard/feedback/${unlockedFeedback.id}`)
      onClose()
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <StyledBox>
        <Typography variant='h5' sx={{ fontWeight: '700', marginBottom: '15px' }}>
          You've received a gift!
        </Typography>
        <Typography sx={{ marginBottom: '25px', color: theme.palette.text.secondary }}>
          Your first review is on us. Consider this complimentary AI feedback our gift to help you
          improve!
        </Typography>
        <FloatingImage src={penguinFlyImg} alt='Penguin' />
        <Button
          variant='contained'
          onClick={handleGoToFeedback}
          fullWidth
          sx={{
            backgroundColor: '#007bff',
            color: 'white',
            padding: '10px 20px',
            marginTop: 'auto',
            '&:hover': {
              backgroundColor: '#0056b3',
            },
          }}
        >
          Go To Feedback
        </Button>
      </StyledBox>
    </Modal>
  )
}

const GiftModalWrapper = () => {
  const [open, setOpen] = useState(false)
  const [getModules] = useLazyModulesGetUserModulesQuery()

  useEffect(() => {
    const checkModules = async () => {
      try {
        const response = await getModules().unwrap()
        if (response.optional.includes('GiftRecordingFeedbackModule')) {
          setOpen(true)
        }
      } catch (error) {
        console.error('Failed to fetch modules:', error)
      }
    }

    checkModules()
  }, [getModules])

  const handleClose = () => {
    setOpen(false)
  }

  return <GiftModal open={open} onClose={handleClose} />
}

export default GiftModalWrapper
